import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';

import styles from './GoToTop.module.scss';
import { GoToTopIcon } from '../Icons/Icons';

const cx = classNames.bind(styles);

function GoToTop() {
    const [active, setActive] = useState(false);

    const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
            window.requestAnimationFrame(scrollToTop);
            window.scrollTo(0, c - c / 8);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 100) {
                setActive(true);
            } else {
                setActive(false);
            }
        });
    }, []);

    return (
        <div className={cx('bottom-container', { active })}>
            <button className={cx('gototop-container')} onClick={scrollToTop}>
                <GoToTopIcon className={cx('gototop-icon')} />
            </button>
        </div>
    );
}

export default GoToTop;
